import { Injectable } from "@angular/core";
import { Address, PortalApiService, Search } from "./portal-api.service";
import { AsyncSubject, forkJoin, of, switchMap, take } from "rxjs";
import { ParamMap } from "@angular/router";
import { PropertyListingService } from "./property.service";
import { GeocodeService } from "../core/services/geocode.service";


@Injectable({
    providedIn: 'root'
})
export class SearchHistoryService {
    private cachedData: any = {};
    private expiresAtMs: number = 60 * 1000; //1hour
    private cacheKeyMask = "userHistory/{URL}"

    constructor(private api: PortalApiService, private propertyListingService: PropertyListingService, private _geocodeService: GeocodeService) {
    }
    public saveHistory(params: ParamMap) {

        if (!this.existsInCasheOrStore(JSON.stringify(params))) {
            let filter = this.propertyListingService.getSearchFiltersFromUrl(params);
            if (filter.type || filter.searchTerm) {
                let type = filter.type ? (filter.type[0]) : undefined;
                let propertyLocation: string | undefined = undefined;
                if (filter.searchTerm && filter.searchTerm.split('!').length > 0) {
                    let locationTerm = filter.searchTerm.split("!")[0]

                    if (locationTerm) {
                        let propertyLocations = locationTerm.split("~");
                        propertyLocation = propertyLocations.length > 1 ? propertyLocations[1] : undefined;
                    }

                }
                
                var placeIds = this.getPlaceIds(params);
                
                this.getPlaces(placeIds)
                    .pipe(switchMap(places => {
                        const addresses = places.map(place => new Address({
                            postalCode: place.PostalCode,
                            administrativeAreas: place.AdministrativeAreas,
                            country: place.Country,
                            geoPoint: (place.Lat && place.Lon) ? `${place.Lat},${place.Lon}` : undefined,
                            prefecture: place.Prefecture,
                            streetNumber: place.StreetNumber,
                            streetName: place.StreetName,
                        }));
                        let searchBody = new Search({
                            placeName: propertyLocation,
                            query: filter,
                            propertyType: type,
                            addresses: addresses
                        })
                        return this.api.upsertSearchHistory(searchBody)
                    })).subscribe();
            }
        }
    }

    private getPlaceIds(params: ParamMap): string[] {
        var searchTerm = params.get('searchTerm');
        let placeIds: string[] = [];
        const areas = searchTerm?.split('!') ?? [];
        areas.forEach(area => {
            let arr = area?.split('~') ?? [];
            // Step 2: Exclude the last value
            arr.pop();
            // Step 3: Take one, leave one, take one, leave one
            
            for (let i = 0; i < arr.length; i += 2) {
                placeIds.push(arr[i]);
            }
        })

        return placeIds;
    }

    private getPlaces(ids: string[]) {
        if (ids.length === 0) {
            return of([]);
        }
        const observables = ids.map(placeId => this._geocodeService.getPlaceById(placeId!).pipe(take(1)));
        return forkJoin(observables);
    }

    private getCacheKey = (url: string) => this.cacheKeyMask.replace("{URL}", url);
    private existsInCasheOrStore(url: string): boolean {
        let key = this.getCacheKey(url);
        if (!this.cachedData[key]) {
            this.cachedData[key] = new AsyncSubject<string>();

            this.cachedData[key] = url;
            setTimeout(() => this.removeDataFromCache(key), this.expiresAtMs);
            return false;
        }
        return true;
    }

    private removeDataFromCache(key: string): void {
        if (this.cachedData[key]) {
            delete this.cachedData[key];
        }
    }
}
